class smFeaturesPage {
  constructor() {
    this.departmentSelector = ".js-features-department";
    this.featuresTabsSelector = ".js-features-tabs";
    this.featuresTabsItemsSelector = ".js-features-tabs-item";
    this.featureItemSelector = ".js-feature-item";

    this.$departments = $(this.departmentSelector);
    this.$featuresTabs = $(this.featuresTabsSelector);
    this.$featuresTabsItems = $(this.featuresTabsItemsSelector);
    this.$featureItem = $(this.featureItemSelector);

    this.defaultDepartmentId = "all";
    this.defaultDepartmentFeatureId = "accept-payment";
  }

  init() {
    this.showDefaultDepartment();
    this.handleEvents();
  }

  getDepartmentById(departmentId) {
    return $(`${this.departmentSelector}[data-id=${departmentId}]`);
  }

  getDepartmentFeaturesTabsById(departmentId) {
    return $(`${this.featuresTabsSelector}[data-department=${departmentId}]`);
  }

  getFeatureItemByIdAndDepartment(featureId, departmentId) {
    return $(`${this.featureItemSelector}[data-id=${featureId}][data-department=${departmentId}]`);
  }

  showDefaultDepartment() {
    const $defaultDepartment = this.getDepartmentById(this.defaultDepartmentId);
    const $defaultDepartmentTabs = this.getDepartmentFeaturesTabsById(this.defaultDepartmentId);
    const $defaultFeatureItem = this.getFeatureItemByIdAndDepartment(
      this.defaultDepartmentFeatureId,
      this.defaultDepartmentId
    );

    $defaultDepartment.addClass("active");
    $defaultDepartmentTabs.addClass("active");
    $defaultFeatureItem.addClass("active");
  }

  handleDepartmentClick(e) {
    const $clickedDepartment = $(e.currentTarget);
    const departmentId = $clickedDepartment.data("id");
    const $departmentFeaturesTabs = this.getDepartmentFeaturesTabsById(departmentId);
    const $activeDepartmentTabItem = $departmentFeaturesTabs.find(".js-features-tabs-item.active");
    const featureId = $activeDepartmentTabItem.data("id");
    const $featureItem = this.getFeatureItemByIdAndDepartment(featureId, departmentId);

    this.$departments.removeClass("active");
    this.$featuresTabs.removeClass("active");
    this.$featureItem.removeClass("active");
    $clickedDepartment.addClass("active");
    $departmentFeaturesTabs.addClass("active");
    $featureItem.addClass("active");
  }

  handleFeatureTabsItemsClick(e) {
    const $clickedTabItem = $(e.currentTarget);
    const featureId = $clickedTabItem.data("id");
    const departmentId = $clickedTabItem.data("department");
    const $departmentTabsItems = this.getDepartmentFeaturesTabsById(departmentId).find(this.featuresTabsItemsSelector);
    const $featureItem = this.getFeatureItemByIdAndDepartment(featureId, departmentId);

    this.$featureItem.removeClass("active");
    $departmentTabsItems.removeClass("active");
    $clickedTabItem.addClass("active");
    $featureItem.addClass("active");
  }

  handleEvents() {
    this.$departments.on("click", (e) => this.handleDepartmentClick(e));
    this.$featuresTabsItems.on("click", (e) => this.handleFeatureTabsItemsClick(e));
  }
}

const smFeaturesPageInstance = new smFeaturesPage();
smFeaturesPageInstance.init();
